import React ,{useState , useEffect} from 'react';
import CustomContactUsCard from './customContactUsCard';
import ImageflagTrukey from '../../assets/images/turkey.webp';
import flagErupa from '../../assets/images/oroba.webp';
import flagKuait from '../../assets/images/flagKuawit.webp';
import ContactUsFormUser from './contactUsForm';
import { useTranslation } from 'react-i18next';
import useLanguageDirection from '../../hooks/useLanguageDirection';

const DataSection = () => {
  const { t ,i18n} = useTranslation();
  const direction = useLanguageDirection();
      
  return (
    <div className='py-3 md:py-10' dir={direction}>
      <div className='max-container'>
        <div className='mx-3 mb-20 space-y-2 md:flex md:space-y-0 md:gap-x-4 lg:mx-0'>
          <div className='w-full md:w-1/3'>
            <CustomContactUsCard
              title={t("Europa")}
              FlagImage={flagErupa}
              Email='support@markaship.com'
              phoneNumberOne='+4367762009102'
              visible={false}
              Location={t("addressEUR")}
              // Location='Van-der-Nuell-Gasse 24/16, Vienna, 1100, Austria'
              Link="https://maps.app.goo.gl/cDDPdbEs1JJV9XxX7"
            />
          </div>

          <div className='w-full md:w-1/3'>
            <CustomContactUsCard
              title={t("Turkey")}
              FlagImage={ImageflagTrukey}
              Email='support@markaship.com'
              phoneNumberOne='+905331586084'
              phoneNumberTwo='+905368346085'
              visible={true}
              Location={t("addressTUR")}
              // Location='ODUNLUK MAH. ORTAÇ SK. NO: 11 A NILÜFER/ BURSA/ Türkiye'
              Link="https://maps.app.goo.gl/QNLvk8ETSZUJKWb17"
            />
          </div>

          <div className='w-full md:w-1/3'>
            <CustomContactUsCard
              title={t("kuwait")}
              FlagImage={flagKuait}
              phoneNumberOne='+96594449324'
              phoneNumberTwo='+96566414164'
              Email='support@markaship.com'
              visible={true}
              Location={t("addressKU")}
              Link="https://maps.app.goo.gl/rzJsofi6E3dVobYR7"
            />
          </div>
        </div>
        
        <ContactUsFormUser />
      </div>
    </div>
  );
}

export default DataSection;
